/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Upload_ResumeInputs */

const en_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload resume`)
};

const de_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf hochladen`)
};

const fr_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharger un CV`)
};

const es_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir currículum`)
};

const it_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica curriculum`)
};

const nl_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV uploaden`)
};

const pl_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wgraj CV`)
};

const fi_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa ansioluettelo`)
};

const da_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload CV`)
};

const sv_resumes_upload_resume = /** @type {(inputs: Resumes_Upload_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda upp CV`)
};

/**
* | output |
* | --- |
* | "Upload resume" |
*
* @param {Resumes_Upload_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_upload_resume = /** @type {((inputs?: Resumes_Upload_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Upload_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_upload_resume(inputs)
	if (locale === "fr") return fr_resumes_upload_resume(inputs)
	if (locale === "es") return es_resumes_upload_resume(inputs)
	if (locale === "it") return it_resumes_upload_resume(inputs)
	if (locale === "nl") return nl_resumes_upload_resume(inputs)
	if (locale === "pl") return pl_resumes_upload_resume(inputs)
	if (locale === "fi") return fi_resumes_upload_resume(inputs)
	if (locale === "da") return da_resumes_upload_resume(inputs)
	if (locale === "sv") return sv_resumes_upload_resume(inputs)
	return en_resumes_upload_resume(inputs)
});